import { Col, Container, Row } from '@themesberg/react-bootstrap'
import { Wrapper } from './MessagePage.styled'
import SafeFormatMessage from '../SafeFormatMessage/SafeFormatMessage'
import logo from '../../../../assets/img/brand/rosas.svg'
const MessagePage = ({
  titleId,
  messageIds,
  icon: Icon,
  variant,
  redirectPath,
  redirectLabelId,
  children,
}) => {
  return (
    <Wrapper>
      <section
        className="d-flex align-items-center"
        style={{ minHeight: '100vh' }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="cardCont shadow-soft border border-round border-light p-4 p-lg-5 w-100 fmxw-500 pb-0">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <img src={logo} alt="RoSaaS Logo" className="logo" />
                  <h3
                    style={{ color: variant, marginRight: '10px' }}
                    className="mb-0"
                  >
                    <Icon /> <SafeFormatMessage id={titleId} />
                  </h3>
                </div>

                {messageIds.map((msgId, index) => (
                  <p className="text-center" key={index}>
                    <SafeFormatMessage id={msgId} />
                  </p>
                ))}
                {children && { children }}
                {redirectPath && (
                  <p className="text-center">
                    <a
                      href={redirectPath}
                      style={{ color: 'var(--second-color)' }}
                    >
                      <SafeFormatMessage id={redirectLabelId} />
                    </a>
                  </p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Wrapper>
  )
}

export default MessagePage
